import React from 'react'
import { CircularProgress, makeStyles } from '@paintscout/ui'

export type SpinningLogoProps = {
  scale?: number
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    animation: '$fadeIn 1s linear 0.2s 1 forwards'
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  }
})

function SpinningLogo({ scale = 1, ...props }: SpinningLogoProps) {
  const classes = useStyles(props)
  const size = 60 * scale

  return (
    <div className={classes.root} style={{ width: size * 1.5, height: size * 1.5 }}>
      <CircularProgress size={size} />
    </div>
  )
}

export default SpinningLogo
